import React from 'react';
import PropTypes from 'prop-types';

const DataExportsHeader = ({ primaryText, secondaryText }) => (
  <header className='exports-header'>
    <div className='primary-text'>
      <h1>
        { primaryText }
      </h1>
    </div>
    {
      secondaryText ?
        <div className='secondary-text'>
          <h2>
            { secondaryText }
          </h2>
        </div> :
      null
    }
  </header>
);

DataExportsHeader.propTypes = {
  primaryText: PropTypes.string.isRequired,
  secondaryText: PropTypes.string,
};

export default DataExportsHeader;



// WEBPACK FOOTER //
// ./modules/DataExports/components/shared/DataExportsHeader.js